module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Staffelbach_AG-9f8cebf928872fbd370aabdd03c75173.svg";